import useWebChatAPIContext from '/druid/useWebChatAPIContext';

export default function useDirFromProps() {
  return [useWebChatAPIContext().dir];
}
